export default __webpack_public_path__ + "static/media/7news.d00c4310.svg";